import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';

interface DeleteDraftParams {
  clientId: string;
  draftId: string;
}

const deleteDraft = ({ clientId, draftId }: DeleteDraftParams) => {
  return authFetch('/Consumer/ManagedAccounts/DeleteAccountOpeningDraft', {
    method: 'POST',
    ...httpBodyOptions({ clientId, managedAccountId: draftId }, true),
  });
};

export const useDeleteDraftMutation = () => {
  return useMutation(deleteDraft);
};
